import {
    Button,
    ChevronEndMediumIcon,
    ChevronStartIcon,
    Flex,
    Input,
    SearchIcon,
} from "@fluentui/react-northstar";

import { Container, ContainerFluid } from "../../common/styles";
import { _str_capitalize } from "../../utils/functions";
import { _api_get_timeline } from "../../features/leave/api";
import RowsIsoWeekNumber from "./components/RowsIsoWeekNumber";
import {
    CalendarTimeline,
    CellTitle,
    DepartementHeader,
    HeaderLeftColumn,
    LeftColumn,
    LeftHeaderColumnCell,
    TextMonth,
    WeeksHeader,
} from "./styles";
import RowsDepartmentsUsers from "./components/RowsDepartmentsUsers";
import RowsDaysName from "./components/RowsDaysName";
import RowsFillTimelineWithData from "./components/RowsFillTimelineWithData";
import DialogSoldeEmployee from "./components/Dialogs/DialogSoldeEmployee";
import SkeletonUsers from "./components/Skeletons/SkeletonUsers";
import SkeletonRows from "./components/Skeletons/SkeletonRows";
import Toast from "../Alerts";
import styled from "styled-components/macro";
import { DEVICE } from "../../constants/responsive";
import { reducer_timeline } from "./reducers/timeline.reducer";
import useLogicTimeline from "./hooks/useLogicTimeline";

const Timeline = ({ isOnManagerPage = false }) => {
    const {
        column_length,
        t,
        query,
        weekends,
        functions,
        isoWeeksAndDays,
        reducer,
        rowsData,
        toast,
    } = useLogicTimeline({ isOnManagerPage });

    return (
        <ContainerFluid>
            <ContainerStyle
                column
                styles={{
                    width: "1335px",
                    paddingTop: "26px",
                    marginTop: "24px !important",
                }}
            >
                <Toast
                    onStatusChange={() =>
                        toast.setConfigToast({
                            visible: false,
                            content: "",
                            level: "warning",
                        })
                    }
                    level={toast.configToast.level}
                    content={toast.configToast.content}
                    visible={toast.configToast.visible}
                />
                <Flex
                    styles={{
                        padding: "px 18px",
                    }}
                >
                    {/* solde de congé d'un employee */}
                    <DialogSoldeEmployee
                        calendar={reducer.calendar}
                        open={reducer.calendar.show_dialog_employee.visible}
                        id_employee={
                            reducer.calendar.show_dialog_employee.user.id
                        }
                        user={reducer.calendar.show_dialog_employee.user}
                        is_manager={isOnManagerPage}
                        onCancelDialog={() =>
                            functions.hideOrShowModalEmployeeSolde({
                                visible: false,
                                user: reducer_timeline.INIT_USER_DATA,
                            })
                        }
                    />
                    <WrapperSearchInput>
                        <Input
                            icon={<SearchIcon />}
                            placeholder={t(
                                "timeline.search_employee.placeholder"
                            )}
                            onChange={(e, i) =>
                                functions.onChangeSearchInput(i?.value)
                            }
                            defaultValue={reducer.calendar.search}
                            fluid
                        />
                    </WrapperSearchInput>
                    <Flex fill gap="gap.large" hAlign="center" vAlign="center">
                        <Flex>
                            <ButtonToday
                                content="Aujourd'hui"
                                size="medium"
                                secondary
                                flat
                                onClick={() =>
                                    reducer.dispatch({
                                        type: reducer_timeline.REDUCER_ACTIONS
                                            .goto_today,
                                    })
                                }
                            />
                        </Flex>
                        <Flex gap="gap.small">
                            <Button
                                icon={<ChevronStartIcon />}
                                iconOnly
                                flat
                                size="medium"
                                onClick={() =>
                                    reducer.dispatch({
                                        type: reducer_timeline.REDUCER_ACTIONS
                                            .decrement,
                                    })
                                }
                            />
                            <Button
                                icon={<ChevronEndMediumIcon />}
                                iconOnly
                                flat
                                size="medium"
                                onClick={() =>
                                    reducer.dispatch({
                                        type: reducer_timeline.REDUCER_ACTIONS
                                            .increment,
                                    })
                                }
                            />
                        </Flex>
                        <Flex>
                            <TextMonth
                                content={`${reducer.calendar.month_name} ${reducer.calendar.year}`}
                            />
                        </Flex>
                    </Flex>
                    <Flex fill styles={{ flex: 1 }}></Flex>
                </Flex>
                <CalendarTimeline column>
                    <WeeksHeader>
                        <HeaderLeftColumn>
                            <LeftHeaderColumnCell
                                vAlign="center"
                                hAlign="center"
                            ></LeftHeaderColumnCell>
                        </HeaderLeftColumn>
                        {/* show rows of badges */}
                        <RowsIsoWeekNumber isoWeeksAndDays={isoWeeksAndDays} />
                    </WeeksHeader>
                    {/* left column */}
                    <Flex>
                        {/* FIRST COLUMN DEPARTMENT */}
                        <LeftColumn column>
                            <DepartementHeader vAlign="center" hAlign="center">
                                <CellTitle content={t("timeline.department")} />
                            </DepartementHeader>
                            {/* loop here department */}
                            {query.isLoadingTimeline ? (
                                <SkeletonUsers />
                            ) : (
                                <RowsDepartmentsUsers
                                    $underlined={true}
                                    timeline={query.timeline}
                                    onClickUser={
                                        functions.hideOrShowModalEmployeeSolde
                                    }
                                    onCollapseDepartment={(department_id) =>
                                        functions.collapseDepartment(
                                            department_id
                                        )
                                    }
                                />
                            )}
                        </LeftColumn>
                        {/* FIRST ROW OF WEEKS */}
                        <Flex column>
                            <RowsDaysName
                                isoWeeksAndDays={isoWeeksAndDays}
                                currentMonth={reducer.calendar.month}
                                currentYear={reducer.calendar.year}
                            />
                            {/* fill data on timeline */}
                            {query.isLoadingTimeline ? (
                                <SkeletonRows />
                            ) : (
                                <RowsFillTimelineWithData
                                    calendar={reducer.calendar}
                                    column_length={column_length}
                                    rowsData={rowsData}
                                    weekends={weekends}
                                    setConfigToast={toast.setConfigToast}
                                />
                            )}
                        </Flex>
                    </Flex>
                </CalendarTimeline>
            </ContainerStyle>
        </ContainerFluid>
    );
};

export default Timeline;

const ContainerStyle = styled(Container)`
    border-top: 4px solid #9299f7;
    background: white;

    /* shadow-16 */
    box-shadow: 0px 6.4px 14.4px 0px rgba(0, 0, 0, 0.13),
        0px 1.2px 3.6px 0px rgba(0, 0, 0, 0.11);

    @media ${DEVICE.mobileS} {
        overflow-x: scroll;
    }
    @media ${DEVICE.laptop} {
        overflow-x: visible;
    }
`;

const WrapperSearchInput = styled(Flex)`
    @media ${DEVICE.mobileS} {
        display: none;
    }
    @media ${DEVICE.laptop} {
        width: 290px;
        display: flex;
    }
`;

export const ButtonToday = styled(Button)`
    @media ${DEVICE.mobileS} {
        min-width: 62px;
        padding: 0px;
        width: 62px;
        height: 32px;
        span {
            font-size: 10px;
            font-weight: 400;
        }
    }
    @media ${DEVICE.laptop} {
        span {
            font-size: 14px;
            font-weight: 600;
        }
        padding: 0px 20px;
        width: fit-content;
        height: 32px;
    }
`;
